import React from "react";
import { IoEyeSharp } from "react-icons/io5";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function PTable() {
  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "Type", field: "purchasetype" },
    { label: "Category", field: "purchasecategory" },
    { label: "Invoice No.", field: "purchaseinvoiceno" },
    { label: "Job Number", field: "jobnumber" },
    { label: "Invoice Date", field: "purchaseinvoicedate" },
    { label: "Supplier Company Name", field: "suppliername" },
    { label: "Warehouse", field: "warehousename" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"PURCHASE"}
        apiField={"purchase"}
        addButton={"+ ADD"}
        createRoute={"/pCreate"}
        updateRoute={"/pView"}
        viewRoute={"/pView"}
      />
    </div>
  );
}

export default PTable;
